import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/mk/501/',
    component: ComponentCreator('/mk/501/', '1a3'),
    exact: true
  },
  {
    path: '/mk/articles/',
    component: ComponentCreator('/mk/articles/', 'a9e'),
    exact: true
  },
  {
    path: '/mk/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/mk/articles/2024/07/09/diskusija-lj-nj-cyrl/', '19e'),
    exact: true
  },
  {
    path: '/mk/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/mk/articles/2024/07/09/diskusija-lj-nj/', '21b'),
    exact: true
  },
  {
    path: '/mk/articles/archive/',
    component: ComponentCreator('/mk/articles/archive/', 'a53'),
    exact: true
  },
  {
    path: '/mk/articles/authors/',
    component: ComponentCreator('/mk/articles/authors/', 'd8e'),
    exact: true
  },
  {
    path: '/mk/search/',
    component: ComponentCreator('/mk/search/', 'f4e'),
    exact: true
  },
  {
    path: '/mk/',
    component: ComponentCreator('/mk/', '93a'),
    exact: true
  },
  {
    path: '/mk/',
    component: ComponentCreator('/mk/', '111'),
    routes: [
      {
        path: '/mk/',
        component: ComponentCreator('/mk/', 'cbe'),
        routes: [
          {
            path: '/mk/tags/',
            component: ComponentCreator('/mk/tags/', 'b18'),
            exact: true
          },
          {
            path: '/mk/tags/comparative/',
            component: ComponentCreator('/mk/tags/comparative/', '386'),
            exact: true
          },
          {
            path: '/mk/tags/grammar/',
            component: ComponentCreator('/mk/tags/grammar/', '1d4'),
            exact: true
          },
          {
            path: '/mk/tags/interslavic/',
            component: ComponentCreator('/mk/tags/interslavic/', '416'),
            exact: true
          },
          {
            path: '/mk/tags/language-learning/',
            component: ComponentCreator('/mk/tags/language-learning/', '888'),
            exact: true
          },
          {
            path: '/mk/tags/linguistics/',
            component: ComponentCreator('/mk/tags/linguistics/', '275'),
            exact: true
          },
          {
            path: '/mk/tags/personal-pronouns/',
            component: ComponentCreator('/mk/tags/personal-pronouns/', '39a'),
            exact: true
          },
          {
            path: '/mk/tags/pronouns/',
            component: ComponentCreator('/mk/tags/pronouns/', 'b0b'),
            exact: true
          },
          {
            path: '/mk/tags/slavic-languages/',
            component: ComponentCreator('/mk/tags/slavic-languages/', '758'),
            exact: true
          },
          {
            path: '/mk/tags/граматика/',
            component: ComponentCreator('/mk/tags/граматика/', '7ec'),
            exact: true
          },
          {
            path: '/mk/tags/заменки/',
            component: ComponentCreator('/mk/tags/заменки/', '50c'),
            exact: true
          },
          {
            path: '/mk/tags/меѓуславјански-јазик/',
            component: ComponentCreator('/mk/tags/меѓуславјански-јазик/', '888'),
            exact: true
          },
          {
            path: '/mk/tags/меѓусловенски/',
            component: ComponentCreator('/mk/tags/меѓусловенски/', '42d'),
            exact: true
          },
          {
            path: '/mk/tags/споредба-на-јазици/',
            component: ComponentCreator('/mk/tags/споредба-на-јазици/', '15f'),
            exact: true
          },
          {
            path: '/mk/tags/учење-јазик/',
            component: ComponentCreator('/mk/tags/учење-јазик/', 'fcd'),
            exact: true
          },
          {
            path: '/mk/',
            component: ComponentCreator('/mk/', '7ae'),
            routes: [
              {
                path: '/mk/learn/faq/',
                component: ComponentCreator('/mk/learn/faq/', '5d3'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/',
                component: ComponentCreator('/mk/learn/grammar/', '231'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/adjectives/',
                component: ComponentCreator('/mk/learn/grammar/adjectives/', '7c8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/conjunctions/',
                component: ComponentCreator('/mk/learn/grammar/conjunctions/', '89e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/nouns/',
                component: ComponentCreator('/mk/learn/grammar/nouns/', 'a29'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/numerals/',
                component: ComponentCreator('/mk/learn/grammar/numerals/', '018'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/prepositions/',
                component: ComponentCreator('/mk/learn/grammar/prepositions/', '7b1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/pronouns/',
                component: ComponentCreator('/mk/learn/grammar/pronouns/', '4a9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/syntax/',
                component: ComponentCreator('/mk/learn/grammar/syntax/', '751'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/verbs/',
                component: ComponentCreator('/mk/learn/grammar/verbs/', 'b70'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/introduction/',
                component: ComponentCreator('/mk/learn/introduction/', 'ca7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/mk/learn/misc/constructed-slavic-languages/', '5f1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/design-criteria/',
                component: ComponentCreator('/mk/learn/misc/design-criteria/', '585'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/history/',
                component: ComponentCreator('/mk/learn/misc/history/', 'aa4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/language-comparison/',
                component: ComponentCreator('/mk/learn/misc/language-comparison/', 'b85'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/numbers-1-10/',
                component: ComponentCreator('/mk/learn/misc/numbers-1-10/', '713'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/mk/learn/misc/pan-slavic-relay/', 'b21'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/personal-pronouns/',
                component: ComponentCreator('/mk/learn/misc/personal-pronouns/', 'ffd'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/orthography/',
                component: ComponentCreator('/mk/learn/orthography/', '9d3'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/phonology/',
                component: ComponentCreator('/mk/learn/phonology/', 'eae'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/pronunciation/',
                component: ComponentCreator('/mk/learn/pronunciation/', '792'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/simple-grammar/',
                component: ComponentCreator('/mk/learn/simple-grammar/', 'd1a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/simple-grammar/level-1/',
                component: ComponentCreator('/mk/learn/simple-grammar/level-1/', '444'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/simple-grammar/level-2/',
                component: ComponentCreator('/mk/learn/simple-grammar/level-2/', '122'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/vocabulary/derivation/',
                component: ComponentCreator('/mk/learn/vocabulary/derivation/', '958'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/mk/learn/vocabulary/flavourisation/', '702'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/vocabulary/word-formation/',
                component: ComponentCreator('/mk/learn/vocabulary/word-formation/', '99a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/resources/',
                component: ComponentCreator('/mk/resources/', 'c24'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/applets/',
                component: ComponentCreator('/mk/resources/applets/', '56a'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/applets/intelligibility/',
                component: ComponentCreator('/mk/resources/applets/intelligibility/', '5c3'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/applets/transliterator/',
                component: ComponentCreator('/mk/resources/applets/transliterator/', '3be'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/keyboards/',
                component: ComponentCreator('/mk/resources/keyboards/', '228'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
